import { frontendURL } from '../../../../helper/URLHelper';

const contacts = (accountId) => ({
  parentNav: 'contacts',
  routes: [
    'contacts_dashboard',
    'contact_profile_dashboard',
    'contacts_importer_dashboard',
    'contacts_segments_dashboard',
    'contacts_labels_dashboard',
    'contacts_lists_dashboard',
    'in_house_contacts_dashboard',
  ],
  menuItems: [
    {
      icon: 'contact-card-group',
      label: 'SIDEBAR.ALL_CONTACTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
      exact: true,
    },
    {
      icon: 'building-shop',
      label: 'SIDEBAR.IN_HOUSE',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/in-house`),
      toStateName: 'in_house_contacts_dashboard',
      requiresInHouse: true,
    },
  ],
});

export default contacts;
